import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Phone, Sparkles, Calendar } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const FLYER_URL = 'https://customer-assets.emergentagent.com/job_368c291c-62c1-4237-a0a2-a0b0ee1658d5/artifacts/rshonl7c_Stage%20tennis.jpeg';
const REGISTRATION_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdsiZohiN5GwTSKtmjKC8CVSgWf00Sb6_rkdzU4PEeisQk5qQ/viewform';

const StageTennisPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [showLightbox, setShowLightbox] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-white">
      <Header scrollY={100} />

      <div className="pt-24 pb-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>

          <div className="mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
              <Sparkles className="w-3.5 h-3.5" />
              Été 2026
            </div>
            <h1 data-testid="stage-tennis-title" className="text-4xl sm:text-6xl font-extrabold text-gray-900 mb-3 leading-tight">
              Stage de tennis
            </h1>
            <p className="text-2xl text-orange-600 font-bold mb-2 flex items-center gap-2">
              <Calendar className="w-6 h-6" />
              Du 17 au 21 août 2026
            </p>
            <p className="text-lg text-gray-600">
              Une semaine pour progresser, s'amuser et partager la passion du tennis 🎾
            </p>
          </div>

          <div className="mb-12 max-w-2xl mx-auto">
            <div
              className="cursor-pointer group rounded-3xl overflow-hidden shadow-2xl hover:shadow-orange-200 transition-all"
              onClick={() => setShowLightbox(true)}
              data-testid="stage-flyer-thumbnail"
            >
              <img
                src={FLYER_URL}
                alt="Flyer Stage de tennis - du 17 au 21 août 2026"
                className="w-full h-auto group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <p className="text-xs text-center text-gray-400 mt-2">Cliquez sur le flyer pour l'agrandir</p>
          </div>

          <div className="bg-gradient-to-br from-gray-900 via-orange-900 to-amber-900 rounded-3xl p-8 sm:p-12 text-white shadow-xl">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">Inscriptions</h2>

            {REGISTRATION_FORM_URL ? (
              <>
                <p className="text-lg text-orange-100 mb-6">
                  Inscris ton enfant en quelques clics via notre formulaire en ligne.
                </p>
                <a
                  href={REGISTRATION_FORM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="stage-register-button"
                  className="inline-flex items-center gap-2 bg-white text-orange-700 hover:bg-orange-50 font-bold px-8 py-4 rounded-full text-lg transition-all hover:scale-105 shadow-lg"
                >
                  Je m'inscris au stage <ArrowLeft className="w-5 h-5 rotate-180" />
                </a>
              </>
            ) : (
              <>
                <p className="text-lg text-orange-100 mb-6">
                  Le formulaire d'inscription en ligne sera disponible très prochainement.
                </p>
                <p className="text-orange-200 mb-2 text-sm uppercase tracking-wider font-bold">En attendant, contactez-nous</p>
                <a
                  href="tel:+41774634181"
                  data-testid="stage-phone-link"
                  className="inline-flex items-center gap-3 bg-white text-orange-700 hover:bg-orange-50 font-bold px-6 py-3 rounded-full text-xl transition-all hover:scale-105 shadow-lg"
                >
                  <Phone className="w-5 h-5" />
                  +41 77 463 41 81
                </a>
              </>
            )}
          </div>
        </div>
      </div>

      {showLightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setShowLightbox(false)}
          data-testid="stage-flyer-lightbox"
        >
          <img
            src={FLYER_URL}
            alt="Flyer Stage de tennis"
            className="max-w-full max-h-[95vh] object-contain rounded-lg shadow-2xl"
          />
          <p className="absolute bottom-6 text-white text-sm bg-black/50 px-4 py-2 rounded-full">
            Cliquez pour fermer
          </p>
        </div>
      )}

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />

      <Footer />
    </div>
  );
};

export default StageTennisPage;
